import Vue from 'vue'
import Popup from './popup/popup'
import Loading from './loading/index'
import Search from './search/search'
import MusicInfo from './musicInfo/index'
import MiniPlayer from './miniPlayer/index'
import Toast from './toast/index'

const Components = {
    Popup,
    Loading,
    Search,
    MusicInfo,
    MiniPlayer,
    Toast,
}

Object.keys(Components).map(key => {
    Vue.component(key, Components[key])
})